import { useContext, useEffect, useState } from "react";
import Wrapper from "../../../components/common/Wrapper/Wrapper";
import organisms from "../../../components/organisms";
import { HeaderHeading } from "../../../Context";
import molecules from "../../../components/molecules";
import constant from "../../../constants/constant";
import { WarrantyModal } from "./warrantyModal";
import service from "../../../api/services";
import { useToasts } from "react-toast-notifications";
import { TParams, TWarrantDetail, TWarrantyData } from "./interface";
import { Default_Page_Limit, Default_Page_Number } from "../../../constants/defaultValues";

const { Warranty } = organisms;
const { CreateSideModal, ConfirmationModal } = molecules;
const Index = () => {
    const { setHeader }: any = useContext(HeaderHeading);
    const { addToast } = useToasts();
    const [showSidebarModal, setShowSidebarModal] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState<string>("");
    const [warrantyData, setWarrantyData] = useState<TWarrantyData>();
    const [warrantDetail, setWarrantyDetail] = useState<TWarrantDetail>();
    const [params, setParams] = useState<TParams>({
        search: "",
        currentPage: Default_Page_Number,
        limitPerPage: Default_Page_Limit,
    });

    // function to get the list of warranty
    const getWarrantyData = async () => {
        try {
            let response = await service.warrantyService.warrantyList({
                page: params?.currentPage,
                search: params?.search,
                limit: params?.limitPerPage,
            });
            if (response.status === 200) {
                setWarrantyData(response.data);
            }
        } catch (error) {
            console.error(error);
        }
    };
    //end

    //function to get the data of item of warranty
    const getWarrantyProductDetail = async (id: string) => {
        try {
            let response = await service.warrantyService?.warrantyDetail(id)
            if (response.status === 200) {
                setWarrantyDetail(response?.data?.data)
            }
        } catch (error) {
            console.error(error)
        }
    }
    //end

    // function to approve and reject the warranty
    const warrantApproveReject = async (
        id: string | undefined,
        warrantyStatus: number
    ) => {
        if (!id) return
        try {
            let response = await service.warrantyService?.warrantyApproveReject(id, {
                status: warrantyStatus,
            });
            if (response.status === 200) {
                getWarrantyData();
            }
        } catch (error: any) {
            console.error(error);
            addToast(error.response.data.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };
    // end

    //function to handle the param change
    const handleParams = (name: string, value: string | number) => {
        setParams(prev => ({
            ...prev,
            [name]: value,
            ...(name !== 'currentPage' && { currentPage: Default_Page_Number }),
          }));
    }
    // end

    useEffect(() => {
        setHeader("Warranty");
        getWarrantyData();
    }, [params]);
    
    return (
        <Wrapper>
            {/* Main Page */}
            <Warranty
                params={params}
                handleParams={(name: string, value: string | number) => handleParams(name, value)}
                warrantyData={warrantyData}
                setShowSidebarModal={(value: boolean) => setShowSidebarModal(value)}
                getWarrantyProductDetail={(id: string) => getWarrantyProductDetail(id)}
            />
            {/* Sidebar Modal */}
            {showSidebarModal && (
                <CreateSideModal
                    show={showSidebarModal}
                    onHide={() => setShowSidebarModal(false)}
                    buttons={[
                        {
                            label: "Reject",
                            onClick: () => setIsOpen(constant.WARRANTY_REJECT_MODAL),
                            className: "fs-16 fw-500 reject-btn",
                        },
                        {
                            label: "Approve",
                            onClick: () => setIsOpen(constant.WARRANTY_APPROVE_MODAL),
                            className: "fs-16 fw-500 approve-btn",
                        },
                    ]}
                    header="Warranty Claim"
                >
                    <WarrantyModal warrantDetail={warrantDetail} />
                </CreateSideModal>
            )}
            {/* Rejection Modal */}
            {isOpen === constant.WARRANTY_REJECT_MODAL && (
                <ConfirmationModal
                    show={!!isOpen}
                    handleConfirmItem={() => {
                        warrantApproveReject(
                            warrantDetail?.id,
                            constant.VERIFICATION_STATUS.REWORK
                        );
                        setShowSidebarModal(false);
                        setIsOpen("");
                    }}
                    onHide={() => setIsOpen("")}
                    message={"reject this warranty claim"}
                />
            )}
            {/* Approval Modal */}
            {isOpen === constant.WARRANTY_APPROVE_MODAL && (
                <ConfirmationModal
                    show={!!isOpen}
                    handleConfirmItem={() => {
                        warrantApproveReject(
                            warrantDetail?.id,
                            constant.VERIFICATION_STATUS.VERIFIED
                        );
                        setShowSidebarModal(false);
                        setIsOpen("");
                    }}
                    onHide={() => setIsOpen("")}
                    message={"approve this warranty claim"}
                />
            )}
        </Wrapper>
    );
};

export default Index;
